import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const DisbandedFilter = ({ filterValue, updateFilters, disabled = false }) => {
  return (
    <FormControl fullWidth={true} variant="outlined" size="small">
      <InputLabel id="disbanded">Disbanded?</InputLabel>
      <Select
        labelId="select-label"
        id="select"
        disabled={disabled}
        fullWidth={true}
        value={filterValue}
        label="Disbanded?"
        onChange={(event) => updateFilters(event.target.value)}
      >
        <MenuItem key={'all'} value={'all'}>
          {'All'}
        </MenuItem>
        <MenuItem key={'true'} value={'true'}>
          {'Yes'}
        </MenuItem>
        <MenuItem key={'false'} value={'false'}>
          {'No'}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default DisbandedFilter;
